const { REACT_APP_LOG_ENV: logEnv } = process.env;
if (logEnv !== 'local') {
  module.exports = require('./configureStore.prod');
} else {
  module.exports = require('./configureStore.dev');
}
